import React from 'react';
import './ui.css';

/**
 * Hive button. variant: 'gold' (primary honey), 'solid' (green), 'ghost'
 * (outline), 'soft' (translucent). size: 'sm' | 'md'.
 */
export default function HiveButton({
  variant = 'gold',
  size = 'md',
  full,
  disabled,
  onClick,
  children,
  type = 'button',
  className = '',
  ...rest
}) {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`hive-btn hive-btn-${variant} hive-btn-${size} hive-tap hive-focusable${
        full ? ' hive-btn-full' : ''
      } ${className}`}
      {...rest}
    >
      {children}
    </button>
  );
}
